import { useMutation } from "@apollo/client/react";
import { DELETE_INVOICE_UPLOAD_UNIT } from "../../mutations/documentHandler/deleteInvoiceUploadUnit";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";

export const useDeleteInvoiceUploadUnit = ({
  onCompleted,
  onError,
}: {
  onCompleted: (data: any) => void;
  onError: (error: any) => void;
}) => {
  const [deleteInvoiceUploadUnit, { data, loading, error }] = useMutation(
    DELETE_INVOICE_UPLOAD_UNIT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    }
  );

  return { deleteInvoiceUploadUnit, data, loading, error };
};
